import { CancelToken } from "axios";
import { useQuery } from "react-query";

import { makeSimpleGetRequest } from "lib/axios";
import { DIRECTORY_URL, ORDERBOOK_URL } from "services/constants";

import { Country, DomainNames, MenuItems, NotificationMessage } from "./types";

export const getMenuItems = (cancelToken?: CancelToken) =>
  makeSimpleGetRequest<MenuItems>(`${ORDERBOOK_URL}/MenuItems/`, {
    cancelToken,
  });

export const getDomainNames = () =>
  makeSimpleGetRequest<DomainNames>(`${ORDERBOOK_URL}/DomainNames/`);

export const getNotificationMessages = () =>
  makeSimpleGetRequest<NotificationMessage[]>(
    `${ORDERBOOK_URL}/NotificationMessages/`,
  );

export const useCountries = () =>
  useQuery(
    ["countries"],
    async () =>
      await makeSimpleGetRequest<Country[]>(`${DIRECTORY_URL}/countries/`),
    {
      staleTime: Infinity,
    },
  );
